import initVueApp from "@/core.js";
const component = require(`./../views/Fabrics.vue`).default;
initVueApp(component);
